import React from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {labels} from '../../../../../../util/utils';
import TaskStatusIcon from '../../../../../Common/TaskBadgeAndName/TaskStatusIcon';
import TaskBadgeAndName from '../../../../../Common/TaskBadgeAndName/TaskBadgeAndName';
import BodySpecialAccordionContentList from '../../../../../Common/CanvasForm/Bodies/BodyTypes/BodySpecial/BodySpecialAccordionContentList';
import {StyledColumnName, StyledColumnValue} from '../Common/StyledConstants';
import PrintViewKnowledgeDescription from '../../Bodies/PrintViewKnowledgeDescription';
import PrintViewSpecialBodyHeader from '../Common/PrintViewSpecialBodyHeader';

function BodySpecialItProcessTask(props) {
	const {body} = props;

	const engagementId = useSelector((store) => Number(store.engagementId)),
		documentEngagementId = useSelector(
			(store) => store?.formPrintData?.documentEngagementId || store?.serverPrintData?.documentEngagementId
		);

	const isTargetEngagement = engagementId !== documentEngagementId;

	const itProcesses = body.itProcesses?.allIds,
		itProcessDetails = body.itProcesses?.byId,
		relatedTasksDetails = body.relatedTasks?.byId;

	const columns = (itProcess) => {
		return [
			{
				width: 100,
				render: (
					<StyledItProcessTaskPrimaryColumn className="StyledItProcessTaskPrimaryColumn">
						<StyledItProcessNameColumn className="StyledItProcessNameColumn">
							<StyledColumnName className="StyledColumnName">{labels.itProcessHeader}</StyledColumnName>
							<StyledColumnValue className="StyledColumnValue">{itProcess.itProcessName}</StyledColumnValue>
						</StyledItProcessNameColumn>
						<StyledItProcessSecondaryColumn className="StyledItProcessSecondaryColumn">
							<StyledColumnName className="StyledColumnName">{labels.itProcessTasksHeader}</StyledColumnName>
							<StyledColumnValue className="StyledColumnValue">
								{itProcess.relatedTasks.length > 0 ? itProcess.relatedTasks.length : ` - `}
							</StyledColumnValue>
						</StyledItProcessSecondaryColumn>
					</StyledItProcessTaskPrimaryColumn>
				)
			}
		];
	};

	return (
		<StyledBodySpecialItProcessTask className="StyledBodySpecialItProcessTask">
			{body && body.id > 0 && <PrintViewKnowledgeDescription body={body} bodyDescription={body.name} />}
			{itProcesses && itProcesses.length > 0 ? (
				itProcesses.map((itProcess) => {
					return (
						<section className="StyledBodyData">
							<PrintViewSpecialBodyHeader columns={columns(itProcessDetails[itProcess])} />
							{itProcessDetails[itProcess].relatedTasks && itProcessDetails[itProcess].relatedTasks.length > 0 ? (
								<BodySpecialAccordionContentList title={labels.itProcessTasksHeader}>
									{itProcessDetails[itProcess].relatedTasks.map((relatedTaskId) => {
										const relatedTask = relatedTasksDetails[relatedTaskId];
										return (
											<StyledBodySpecialGridPrimaryColumn className="related-task-list-item">
												<TaskStatusIcon taskStatusId={relatedTask.taskStatusId} isEPEQRSignOffComplete />
												<TaskBadgeAndName
													taskId={relatedTask.id}
													taskTypeId={relatedTask.taskTypeId}
													isEp={relatedTask.isEPTask}
													isEq={relatedTask.isEQRTask}
													taskName={relatedTask.taskName}
													linesBeforeEllipse={1}
													badgeOnNewLine={false}
													noBackground
													showLink={false}
													taskClassName="isa315-itprocess-task-list-item-content-task"
													viewType="listView"
													linkNewWindow={false}
													isEllipsed={false}
												/>
											</StyledBodySpecialGridPrimaryColumn>
										);
									})}
								</BodySpecialAccordionContentList>
							) : (
								<section className="emptyContainer">
									{!isTargetEngagement
										? labels.itProcessSourceInstructionalText
												.replace(
													'{itProcessSourceInstructionalTextRelateUdp}',
													labels.itProcessSourceInstructionalTextRelateUdp
												)
												.replace(
													'{itProcessSourceInstructionalTextCreateUdp}',
													labels.itProcessSourceInstructionalTextCreateUdp
												)
										: labels.itProcessTargetInstructionalText}
								</section>
							)}
						</section>
					);
				})
			) : (
				<section className="emptyContainer">{labels.relateUDPNoDataPlaceHolder}</section>
			)}
		</StyledBodySpecialItProcessTask>
	);
}

export default BodySpecialItProcessTask;

const StyledBodySpecialItProcessTask = styled.section`
	display: flex;
	flex-direction: column;
	.StyledPrintViewKnowledgeDescription {
		font-size: var(--px-14);
		font-weight: 300;
		line-height: var(--px-20);
		& + .emptyContainer {
			padding: var(--px-10) 0 !important;
		}
	}
	.StyledBodyData {
		background-color: var(--neutrals-00white);
		border: var(--px-1) solid var(--neutrals-200);
		margin-top: var(--px-20);
		width: 100%;
		display: flex;
		flex-direction: column;
		.StyledHeaderContainer {
			background-color: var(--neutrals-00white);
			.StyledSimpleHeader {
				padding-left: 0;
			}
		}
		.StyledBodySpecialAccordionContentList {
			background-color: var(--neutrals-25);
			padding-left: var(--px-30);
			overflow: hidden !important;
			.StyledBodySpecialAccordionContentListTitle {
				padding-bottom: var(--px-10);
				font-size: var(--px-14);
				font-weight: 300;
				border-bottom: var(--px-1) solid var(--neutrals-200);
			}
		}
	}
	.emptyContainer {
		color: var(--neutrals-900);
		display: flex;
		align-items: center;
		height: 100%;
		justify-content: left;
		font-size: var(--px-14);
		font-weight: 300;
		padding: var(--px-10) var(--px-30) !important;
	}
`;

const StyledItProcessTaskPrimaryColumn = styled.section`
	display: flex;
`;

const StyledItProcessNameColumn = styled.section`
	width: 95%;
`;

const StyledItProcessSecondaryColumn = styled.section`
	width: 5%;
`;

const StyledBodySpecialGridPrimaryColumn = styled.section`
	display: flex;
	&.related-task-list-item {
		padding: var(--px-10) 0;
		border-bottom: var(--px-1) solid var(--neutrals-200);
		width: 100%;
		&:last-child {
			border-bottom: 0;
			padding-bottom: 0;
		}
		.StyledTaskStatusIcon {
			padding-top: var(--px-4);
		}
		.isa315-itprocess-task-list-item-content-task {
			padding: 0;
			border: 0;
			display: flex;
			align-items: flex-start;
			width: calc(100% - var(--px-30));
			.TaskBadges {
				padding: var(--px-1) var(--px-5) var(--px-1) 0;
			}
		}
	}
`;
